import styles from "./no-content.module.css";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";

interface NoPageContentProps {
  title?: string;
  subtitle?: string;
  message?: string;
  iconName?: UIIconName;
}

export const NoPageContent = (props: NoPageContentProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {props.iconName && (
          <UIIcon iconName={props.iconName} variant="REGULAR" />
        )}
        {props.title && <h2>{props.title}</h2>}
        {props.subtitle && <h3>{props.subtitle}</h3>}
        {props.message && <p>{props.message}</p>}
      </div>
    </div>
  );
};
